export default __webpack_public_path__ + "static/media/img-time-l-8.1076a47d.svg";